export const SET_AUTOPLAY = 'SET_AUTOPLAY';

export function setAutoplay(autoPlay = true) {
    return {
        type: SET_AUTOPLAY,
        payload: autoPlay,
        persistent: true,
    };
}
